import React, { useState } from 'react';
import SearchStaffUser from '../../Utilities/SerchStafUser';
import setUiMessage from '../../Utilities/Tostify';
import ConfirmDialog from '../../Utilities/ConfirmDialog';
import { post } from '../Auths/AuthToken';
import { useSelector } from 'react-redux';

function ComAddGrpPopup({ grpsArr, handleReload, close }) {
  const { user } = useSelector((state) => state.auth);
  const [taggedStaff, setTaggedStaff] = useState([]);
  const [grpName, setGrpName] = useState('');
  const [isDefault, setIsDefault] = useState('0');
  const [confirmDelPopup, setConfirmDelPopup] = useState(false);
  const [grpId, setGrpId] = useState('');
  const [updateButton, setUpdateButton] = useState(false);

  const handleRecord = async () => {
    if (grpName) {
      if (taggedStaff && taggedStaff.length > 0) {
        try {
          const response = await post(
            'api/communication/Communication/handleGroupData',
            {
              name: grpName,
              staff: taggedStaff.map((item) => item.staff_id),
              default: isDefault,
              loginUserId: user?.id,
            }
          );
          if (response?.status === 200) {
            if (response?.data?.status === 'error') {
              setUiMessage('inf', response?.data?.message);
            } else {
              setUiMessage('suc', 'Group added successfully.');
              setGrpName('');
              setTaggedStaff([]);
              setIsDefault('0');
              handleReload();
            }
          }
        } catch (error) {
          setUiMessage('err', error.message);
        }
      } else {
        setUiMessage('err', 'Please select the staff.');
      }
    } else {
      setUiMessage('err', 'Please enter the group name.');
    }
  };

  const handleChange = (groupDetails) => {
    if (groupDetails) {
      setUpdateButton(true);
      setGrpName(groupDetails?.group_name);
      // Split the tag_user string into an array of numbers
      const tagUsers = groupDetails.tag_user.split(',');
      // Create the array of objects with staffName and staff_id properties
      const taggedUserArray = tagUsers.map((tagUserId, index) => ({
        staffName: groupDetails.tag_user_name[index],
        staff_id: tagUserId,
      }));
      setTaggedStaff(taggedUserArray);
      setIsDefault(groupDetails?.default_group);
      setGrpId(groupDetails?.id);
    }
  };

  const handleCancel = () => {
    setUpdateButton(false);
    setGrpName('');
    setTaggedStaff([]);
    setIsDefault('0');
    setGrpId('');
  };

  const handleUpdate = async () => {
    if (grpName) {
      if (taggedStaff && taggedStaff.length > 0) {
        try {
          const response = await post(
            'api/communication/Communication/handleGroupData',
            {
              name: grpName,
              staff: taggedStaff.map((item) => item.staff_id),
              default: isDefault,
              loginUserId: user?.id,
              tagId: grpId, //in case of update
            }
          );
          if (response?.status === 200) {
            if (response?.data?.status === 'error') {
              setUiMessage('inf', response?.data?.message);
            } else {
              setUiMessage('suc', 'Group updated successfully.');
              setUpdateButton(false);
              setGrpName('');
              setTaggedStaff([]);
              setIsDefault('0');
              handleReload();
            }
          }
        } catch (error) {
          setUiMessage('err', error.message);
        }
      } else {
        setUiMessage('err', 'Please select the staff.');
      }
    } else {
      setUiMessage('err', 'Please enter the group name.');
    }
  };
  const handleDelete = (groupDetails) => {
    setGrpId(groupDetails?.id);
    setConfirmDelPopup(true);
  };
  const handleDeleteConfirm = async (groupId) => {
    try {
      const response = await post(
        'api/communication/Communication/deleteDefaultGroupData',
        {
          tagId: groupId,
        }
      );
      if (response?.status === 200) {
        setUiMessage('suc', 'Group deleted Successfully.');
        setUpdateButton(false);
        setGrpName('');
        setTaggedStaff([]);
        setIsDefault('0');
        handleReload();
      }
    } catch (error) {
      setUiMessage('err', error.message);
    }
  };
  return (
    <>
      <div className="modalBackground">
        <div className="compose-msg-main-con grid-sec tab-bg">
          <div className="comp-msg-hdr flex-sec">Manage Group</div>
          <div className="comp-msg-bdy grid-sec">
            <div className="comp-msg-bdy-rw flex-sec">
              <span className="msg-bdy-rw-bl">
                Group name:<span className="red">*</span>
              </span>
              <span className="msg-bdy-rw-val">
                <input
                  type="text"
                  className="msg-inpt"
                  onChange={(e) => setGrpName(e.target.value)}
                  value={grpName}
                />
              </span>
            </div>
            <SearchStaffUser
              fieldName={'Staff'}
              key={Math.random()} // Ensure re-rendering when the key changes
              tagStaffUser={taggedStaff}
              handleTaggedStaff={(staffs) => setTaggedStaff(staffs)}
            />
            <div className="comp-msg-bdy-rw flex-sec">
              <span className="msg-bdy-rw-bl">&nbsp;</span>
              <span className="msg-bdy-rw-val">
                <input
                  id="checkReadUnread"
                  type="checkbox"
                  onChange={(e) => setIsDefault(e.target.checked ? '1' : '0')}
                  checked={isDefault === '1'}
                  title="check for unread"
                />
                <span className="clear-left10">Default group</span>
                {updateButton ? (
                  <>
                    <button
                      className="actn-yes"
                      onClick={handleUpdate}
                      style={{ marginRight: '0px' }}
                    >
                      Update
                    </button>
                    <button
                      className="actn-No"
                      onClick={handleCancel}
                      style={{ marginRight: '0px' }}
                    >
                      Cancel
                    </button>
                  </>
                ) : (
                  <button
                    className="actn-yes"
                    onClick={handleRecord}
                    style={{ marginRight: '0px' }}
                  >
                    Record
                  </button>
                )}
              </span>
            </div>
            <div className="comp-msg-ftr flex-sec"></div>
            <div>
              <div className="com-gr-hdr">
                <span className="left clear-left10" style={{ width: '140px' }}>
                  Group Name
                </span>
                <span className="left clear-left10" style={{ width: '290px' }}>
                  Attached users
                </span>
                <span className="left clear-left10" style={{ width: '120px' }}>
                  Action
                </span>
              </div>
              <div className="nurse-note-popup-lower-block width100">
                {grpsArr &&
                  grpsArr.length > 0 &&
                  grpsArr.map((item, i) => {
                    return (
                      <div
                        className="left width100"
                        style={{
                          padding: '9px 0px 9px 0px',
                          borderBottom: '1px dotted #dadada',
                        }}
                        key={i}
                      >
                        <span
                          className="left clear-left10"
                          style={{ width: '140px' }}
                        >
                          {item?.group_name}
                        </span>
                        <span
                          className="left clear-left10"
                          style={{ width: '290px' }}
                        >
                          {item.tag_user_name
                            .map((staffNames) => staffNames)
                            .join(', ')}
                        </span>{' '}
                        <span
                          className="left clear-left10"
                          style={{ width: '120px' }}
                        >
                          <span className="">
                            <span
                              className="link-color"
                              onClick={() => handleChange(item)}
                            >
                              Change
                            </span>
                          </span>
                          <span className="red clear-right clear-left10 qhide">
                            |
                          </span>
                          <span className="qhide">
                            <span
                              className="link-color"
                              onClick={() => handleDelete(item)}
                            >
                              Delete
                            </span>
                          </span>
                        </span>
                      </div>
                    );
                  })}
              </div>
            </div>
          </div>
          <div className="comp-msg-ftr flex-sec">
            <button className="actn-No" onClick={close}>
              Close
            </button>
          </div>
        </div>
        {confirmDelPopup && (
          <ConfirmDialog
            title="Group"
            bodytext={'Do you really want to delete this Group?'}
            closeDialog={() => setConfirmDelPopup(false)}
            successDialog={handleDeleteConfirm}
            sucPrams={grpId}
          />
        )}
      </div>
    </>
  );
}

export default ComAddGrpPopup;
